import { observable } from 'mobx';

export type MeetingTitleHistoryArgs = {
  title: string;
};

export default class MeetingTitleHistory {
  @observable title: string;

  constructor(args: MeetingTitleHistoryArgs) {
    this.title = args.title;
  }
}
